import React, { useContext, useEffect, useRef, useState } from 'react';

import { ItemsList } from '@/components/shared/ItemsList';
import { useErrorHandler } from '@/hooks/useErrorHandler';
import { useAuth } from '@/providers/AuthProvider';
import { useEnvironment } from '@/providers/EnvironmentProvider';
import * as Sentry from '@sentry/react';
import axios from 'axios';

import { CopilotContext, CopilotState } from '../CopilotPage';

const CopilotFetchSongs: React.FC = () => {
	const { enqueueSnackbar, token, authData, pcoSongs, setState } =
		useContext(CopilotContext);
	const { api, environment } = useEnvironment();
	const { authenticate } = useAuth();
	const { handleError } = useErrorHandler();
	const intervalRef = useRef<number | null>(null);
	// const hasMounted = useRef<boolean>(false);

	const [isConnected, setIsConnected] = useState(false);
	const [totalSongs, setTotalSongs] = useState(0);
	const [processedSongs, setProcessedSongs] = useState(0);

	useEffect(() => {
		const runAsync = async () => {
			try {
				if (!token) {
					throw new Error('No token');
				}
				const res = await axios.post<{
					totalSongs: number;
					progressId: number;
				}>(
					`${api.url}/copilot/add-songs`,
					{
						songs: pcoSongs,
					},
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					},
				);
				setTotalSongs(res.data.totalSongs);

				intervalRef.current = window.setInterval(async () => {
					const progressRes = await axios<{
						id: number;
						userId: number;
						processedSongs: number;
						totalSongs: number;
						service: string;
						completed: boolean;
					}>(
						`${api.url}/copilot/add-songs/get-progress/${res.data.progressId}`,
						{
							method: 'POST',
							headers: {
								Authorization: `Bearer ${token}`,
							},
						},
					);

					setProcessedSongs(progressRes.data.processedSongs);
					if (progressRes.data.completed) {
						setState(CopilotState.LoggingIn);
					}
				}, 2000);
			} catch (err) {
				Sentry.captureMessage('Song import error', 'warning');
				setState(CopilotState.Error);
				console.log(err);
				enqueueSnackbar('Error fetching songs');
			}
		};
		// if (!hasMounted.current) {
		// hasMounted.current = true;
		runAsync();
		// }

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		};
	}, [authenticate, enqueueSnackbar, pcoSongs, setState, token, api.url]);
	return (
		<>
			<h2>Progress</h2>
			<ItemsList
				items={[
					{
						label: 'Account verified',
						checked: true,
					},
					{
						label: `Prepared ${pcoSongs.length} songs`,
						checked: true,
					},
					{
						label: `Importing songs (${processedSongs}/${totalSongs})... `,
						checked: false,
					},
				]}
			/>
		</>
	);
};

export default CopilotFetchSongs;
